import Button from '@american-autonomy/ag-ui/dist/components/buttons/Button';
import HorizontalContainer from '@american-autonomy/ag-ui/dist/components/containers/HorizontalContainer';

import ErrorIcon from 'components/icons/ErrorIcon';
import BaseNotification from 'components/notifications/BaseNotification';
import LabelText from 'components/text/LabelText';

import useTranslation from './hooks/useTranslation';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const ErrorNotification: FunctionComponent<Props> = ({
    onClick,
    onClose,
    testId = TEST_ID,
    text
}) => {
    const { TRY_AGAIN } = useTranslation();

    return (
        <BaseNotification
            className={styles.errorNotification}
            onClick={onClick}
            onClose={onClose}
            testId={testId}
            text={text}>
            <HorizontalContainer className={styles.iconTextContainer}>
                <ErrorIcon />

                <LabelText className={styles.messageLabelText} text={text} />
            </HorizontalContainer>

            {onClick && (
                <Button className={styles.button} onClick={onClick}>
                    <LabelText className={styles.buttonLabelText} text={TRY_AGAIN} />
                </Button>
            )}
        </BaseNotification>
    );
};

export default ErrorNotification;
